module.exports = __webpack_public_path__ + "img/jg1.40133e3d.png";